var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"pa-4 elevation-0",staticStyle:{"border":"1px solid #ccc"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12"}},[_c(_setup.StockWithBOMTable,{attrs:{"headers":_setup.bomSearchHeaders,"items":_setup.bomList,"useLocalChildren":true,"props":{
          tableClass: 'elevation-0',
        }}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }